import React, { FC, useEffect, useState } from "react"
import { Box, Loader } from "@strapi/design-system"

interface ActivateAccountHubspotFormProps {
  onSubmit: () => void
}

const SCRIPT_SRC = "https://js.hsforms.net/forms/embed/v2.js"
const PORTAL_ID = "4992313"
const FORM_ID = "acefa00c-64ea-4dc4-8f96-e92d037b5b67"
const TARGET_FORM_CONTAINER = "hubspotForm"

const ActivateAccountHubspotForm: FC<ActivateAccountHubspotFormProps> = ({ onSubmit }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const script = document.createElement("script")
    script.src = SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      //@ts-expect-error - hbspt is added by HubSpot script
      if (window.hbspt) {
        //@ts-expect-error - hbspt is added by HubSpot script
        window.hbspt.forms.create({
          portalId: PORTAL_ID,
          formId: FORM_ID,
          target: `#${TARGET_FORM_CONTAINER}`,
          css: `          
              .hs-form {
                width: 100%;
                max-width: 600px;
                margin: 0 auto;
                font-family: Arial, sans-serif;
                color: #FFF;
              }
              .hs-form label {
                display: block;
                font-size: 13px;
                font-weight: 700;
                line-height: 13px;
                text-align: left;
                margin-bottom: 5px;
                margin-top: 15px;
                &.hs-error-msg { 
                margin-top: 0px;
                font-weight: 500;
                }
              }
              .hs-form input[type="text"],
              .hs-form input[type="email"] {
                width: 100%;
                padding: 10px;
                height: 40px;
                border: 1.5px solid #DCDCE3;
                border-radius: 4px;
                font-size: 16px;
                color: #333;
                outline: none;
                margin-bottom: 5px;
              }
              .hs-form input[type="text"]:focus,
              .hs-form input[type="email"]:focus {
                border: 1.5px solid #474748;
              }
              .hs-form .input .invalid,
              .hs-form .input .invalid:focus {
                color: #E64F4F;
                border: 1.5px solid #E64F4F; 
                background-color: #FCEDED;   
              }
              .hs-error-msg {
                color: #d9534f; 
                font-size: 14px;
                margin-bottom: 0px;
                display: none; 
              }
              .hs-form .error .hs-error-msg {
                display: block; 
              }
              .hs-form .hs-button.primary {
                width: 100%;
                padding: 12px;
                font-size: 16px;
                font-weight: bold;
                background-color: #4846F6;
                color: #fff;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                transition: background-color 0.3s ease;
                margin-top: 15px;
              }
              .hs-form .hs-button.primary:hover {
                background-color: #3a3ed1; 
              }
              .hs-form .hs-button.primary:focus {
                outline: none;
                box-shadow: 0 0 0 2px rgba(72, 70, 246, 0.3);
              }
              .hs_error_rollup {
                display: none;
                height: 0;
              }
              .inputs-list label a {
                display: none;
                height: 0;
              }
          `,
          onFormSubmitted: () => {
            onSubmit()
          },
        })
        setIsLoading(false)
      }
    }

    return () => {
      document.body.removeChild(script)
    }
  }, [onSubmit])

  return (
    <Box
      id={TARGET_FORM_CONTAINER}
      style={{
        width: "250px",
        minHeight: "211px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isLoading && <Loader />}
    </Box>
  )
}

export default ActivateAccountHubspotForm
